import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vj-footer',
  templateUrl: './vj-footer.component.html',
  styleUrls: ['./vj-footer.component.css']
})
export class VjFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  getSupport(){
    
  }

}
